var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkbox-wrapper", class: { disabled: _vm.disabled } },
    [
      _c("input", {
        ref: "checkbox",
        staticClass: "k-checkbox custom-kendo-checkbox-for",
        attrs: { type: "checkbox" },
        domProps: { checked: _vm.checked }
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "k-checkbox-label",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              $event.preventDefault()
              return _vm.clicked($event)
            }
          }
        },
        [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }